import MobileAppSection from './MobileAppSection';

export default MobileAppSection;